export default "__VITE_ASSET__BsKkVAj7__"